import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import React, { useTransition } from 'react';

import { ConditionalRender, Skeleton } from '@crossnokaye/ux-common';

import { useSelectEquipment } from '@/features/equipment-browser/equipment-details/hooks/use-select-equipment';
import { Button } from '@/ux-common/components/button/button';
import { Inline } from '@/ux-common/components/inline/inline';

import { JumpToEquipmentDropdown } from './jump-to-equipment-dropdown';

interface PrevNextButtonsProps {
  className?: string;
  isLoading?: boolean;
}

export const PrevNextButtons = ({
  isLoading,
  className,
}: PrevNextButtonsProps): React.ReactNode => {
  const [isPending, startTransition] = useTransition();
  const { selectPreviousAction, selectNextAction } = useSelectEquipment();

  const handlePrevious = () => {
    startTransition(async () => {
      await selectPreviousAction();
    });
  };

  const handleNext = () => {
    startTransition(async () => {
      await selectNextAction();
    });
  };

  return (
    <Inline className={`inline-row-sm flex-nowrap ${className}`}>
      <ConditionalRender condition={!isLoading && !isPending} fallback={<Skeletons />}>
        <Button
          className="btn btn-md"
          onClick={handlePrevious}
          disabled={isPending}
          aria-label="Previous equipment"
        >
          <ArrowLeftIcon className="btn-icon" aria-hidden="true" />
        </Button>
        <JumpToEquipmentDropdown />
        <Button
          className="btn btn-md"
          onClick={handleNext}
          disabled={isPending}
          aria-label="Next equipment"
        >
          <ArrowRightIcon className="btn-icon" aria-hidden="true" />
        </Button>
      </ConditionalRender>
    </Inline>
  );
};

const Skeletons = () => {
  return (
    <>
      <Skeleton className="w-10 h-9" />
      <Skeleton className="w-10 h-9" />
      <Skeleton className="w-10 h-9" />
    </>
  );
};
